import type { Alarm, InputView, OutputState } from "../api/types";
import { INPUT_HEALTH_LABEL, inputHealth, OUTPUT_STATE_LABEL, type InputHealth } from "../lib/format";
import { t } from "../lib/i18n";
import { Pill, type Tone } from "./ui";

export const HEALTH_TONE: Record<InputHealth, Tone> = {
  online: "ok", degraded: "warn", offline: "err", disabled: "muted",
};

export const OUTPUT_TONE: Record<OutputState, Tone> = {
  stopped: "muted", waiting: "warn", starting: "accent", running: "ok", retrying: "err", unknown: "muted",
};

export function InputHealthPill({ input, alarms }: { input: InputView; alarms: Alarm[] }) {
  const health = inputHealth(input, alarms);
  return <Pill tone={HEALTH_TONE[health]} pulse={health === "online"}>{t(INPUT_HEALTH_LABEL[health])}</Pill>;
}

export function OutputStatePill({ state }: { state: OutputState }) {
  return <Pill tone={OUTPUT_TONE[state]} pulse={state === "running"}>{t(OUTPUT_STATE_LABEL[state])}</Pill>;
}

/** Couleur de la bordure « tally » au-dessus d'une tuile. */
export const HEALTH_BORDER: Record<InputHealth, string> = {
  online: "border-t-ok", degraded: "border-t-warn", offline: "border-t-err", disabled: "border-t-line",
};
